import "./ChatPage.scss";
import type React from "react";
import {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {Box} from "@mui/material";
import {Outlet, useNavigate, useParams} from "react-router";
import {SimpleEnvWrapper} from "../../jobs/wrapper/SimpleEnvWrapper";
import {LoadingBarComponent} from "../../components/loading-bar/LoadingBarComponent.tsx";
import {useStores} from "../../stores";
import {tryGeneratePath} from "../../routing/routing.utils";
import {Sidebar} from "./components/Sidebar";
import {useChatAvailableForActiveDatabag} from "./hooks/useChatAvailableForActiveDatabag";

const CHAT_PAGE_CONTENT_SX = {
    display: "flex",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
} as const;

const ChatLayoutContent: React.FC = observer(() => {
    const navigate = useNavigate();
    const params = useParams();
    const {bagStore} = useStores();
    const {isReady, isAvailable} = useChatAvailableForActiveDatabag();

    useEffect(() => {
        if (!isReady || isAvailable) {
            return;
        }
        const path = tryGeneratePath(
            params,
            ["homepage_dashboard", "home"],
            bagStore.bagId,
        );
        if (path) {
            navigate(path, {replace: true});
        }
    }, [isReady, isAvailable, navigate, params, bagStore.bagId]);

    if (isReady && !isAvailable) {
        return <LoadingBarComponent/>;
    }

    return (
        <>
            <LoadingBarComponent/>
            <main id="main-component-content">
                <div id="main-page-facade" className="chat-page">
                    <Box className="chat-page-content" sx={CHAT_PAGE_CONTENT_SX}>
                        <Sidebar/>
                        <Outlet/>
                    </Box>
                </div>
            </main>
        </>
    );
});

/** Parent route layout for chat + dashboards. Databag env stays on SimpleEnvWrapper. */
export const ChatLayout: React.FC = () => (
    <SimpleEnvWrapper state={{fluid: true}}>
        <ChatLayoutContent/>
    </SimpleEnvWrapper>
);
